var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IxVectorLayer',{attrs:{"features":_vm.errorFeatures,"vector-style":_vm.vectorStyle}})}
var staticRenderFns = []

export { render, staticRenderFns }